/* eslint-disable func-names */
/* eslint-disable no-undef */
const burger = () => {
  (function ($) {
    // elements
    const $window = $(window);
    const body = $("body");
    const $burger = $(".js-burger");
    const $burgerIcon = $(".c-burger");
    const $header = $(".c-header");
    const $navMain = $(".js-navigation");
    const $list = $(".c-navigation__list");
    const $languages = $(".c-languages");
    const $searchBar = $(".c-search-bar");
    const $accordionHeader = $(".o-accordion-header--level-0");
    const $accordionPanel = $(".js-accordion-panel");
    const $accordionPanelLevel2 = $('[data-menu-level="2"]');
    const $accordionPanelLevel3 = $('[data-menu-level="3"]');
    const isMobileTablet = $window.width() < 1024;

    // classes
    const headerActive = "c-header--active";
    const open = "c-navigation--active";
    const active = "c-burger--active";
    const listVisible = "c-navigation__list--visible";
    const languagesVisible = "c-languages--visible";
    const searchBarVisible = "c-search-bar--visible";
    const overflowHidden = "overflow-hidden";
    const accordionHeaderOpen = "o-accordion-header--open";
    const accordionIconOpen = "o-accordion-icon--open";

    if (isMobileTablet) {
      $burger.on("click", () => {
        body.toggleClass(overflowHidden);
        $burgerIcon.toggleClass(active);
        $header.toggleClass(headerActive);
        $list.toggleClass(listVisible);
        $languages.toggleClass(languagesVisible);
        $searchBar.toggleClass(searchBarVisible);
        $navMain.toggleClass(open);

        const isOpen = $accordionHeader.hasClass(accordionHeaderOpen);

        // reset main menu
        if (isOpen) {
          $accordionHeader.removeClass(accordionHeaderOpen);
          $accordionHeader.children().removeClass(accordionIconOpen);
          $accordionPanel.hide();
          $accordionPanelLevel2.removeClass("open").removeAttr("style");
          $accordionPanelLevel3.removeClass("open").removeAttr("style");
        }
      });
    }
  })(jQuery);
};

export default burger;
